import React, { useState, useEffect } from 'react';
import './works.css';
import Portfolio1 from '../../assets/QuizApp.png';
import Portfolio2 from '../../assets/NotesApp.png';
import Portfolio3 from '../../assets/WeatherApp.png';
import Portfolio4 from '../../assets/ToDoListApp.png';
import Portfolio5 from '../../assets/RandomPasswordApp.png';
import Portfolio6 from '../../assets/calculatorapp.png';
import Portfolio7 from '../../assets/RecinosApp2.png';
import Portfolio8 from '../../assets/AlloApp1.png';
import Portfolio9 from '../../assets/bosteklogo.png';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Works = () => {
  const [showMore, setShowMore] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  const projects = [
        { img: Portfolio9, link: "https://www.bostek.co/", alt: "Bostek" },
    { img: Portfolio7, link: "https://recinos-construction-llc.firebaseapp.com/", alt: "Recinos Construction" },
    { img: Portfolio8, link: "", alt: "Allo App", description: "An app created for Allo Fiber Internet in order to automate the process of BOM (Bill of Materials Generation). Many steps go into the creation and compilation of BOMs so having this process automated was necessary." },
    { img: Portfolio5, link: "https://github.com/EldinSalja/random-password-app", alt: "Random Password App" },
    { img: Portfolio6, link: "https://github.com/EldinSalja/calculator-app", alt: "Calculator App" },
    { img: Portfolio3, link: "https://github.com/EldinSalja/weather-app", alt: "Weather App" },
    { img: Portfolio4, link: "https://github.com/EldinSalja/todo-list-app", alt: "To-Do List App" },
    { img: Portfolio2, link: "https://github.com/EldinSalja/notes-app", alt: "Notes App" },
    { img: Portfolio1, link: "https://github.com/EldinSalja/simple-quiz-app", alt: "Quiz App" }
  ];

  // Helper to handle Allo App click
  const handleAlloClick = (e, project) => {
    e.preventDefault();
    setSelectedProject(project);
  };

  return (
    <section id='works'>
      <h2 className="worksTitle">My Portfolio</h2>
      <span className="worksDesc">I take pride in paying attention to the small details...</span>

      <div className="worksImgs">
        {projects.slice(0, 4).map((project, index) =>
          project.alt === "Allo App" ? (
            <button
              type="button"
              className="worksCardBtn"
              key={index}
              data-aos="fade-up"
              onClick={e => handleAlloClick(e, project)}
            >
              <img src={project.img} alt={project.alt} className="worksImg" />
            </button>
          ) : (
            <a
              key={index}
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              data-aos="fade-up"
            >
              <img src={project.img} alt={project.alt} className="worksImg" />
            </a>
          )
        )}

        <div className={`extraProjects ${showMore ? 'show' : 'hide'}`}>
          {projects.slice(4).map((project, index) =>
            project.alt === "Allo App" ? (
              <button
                type="button"
                className="worksCardBtn"
                key={index + 4}
                onClick={e => handleAlloClick(e, project)}
              >
                <img src={project.img} alt={project.alt} className="worksImg" />
              </button>
            ) : (
              <a
                key={index + 4}
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={project.img} alt={project.alt} className="worksImg" />
              </a>
            )
          )}
        </div>
      </div>

      {selectedProject && (
        <div className="modalOverlay" onClick={() => setSelectedProject(null)}>
          <div className="modalContent" onClick={e => e.stopPropagation()}>
            <h2>{selectedProject.alt}</h2>
            <p>{selectedProject.description}</p>
            <button onClick={() => setSelectedProject(null)}>Close</button>
          </div>
        </div>
      )}

      <button className="seeMoreBtn" onClick={handleToggle}>
        {showMore ? 'See Less' : 'See More'}
      </button>
    </section>
  );
};

export default Works;